import React from 'react';
import { ServiceDetailPage } from '../../components/ServiceLayout/ServiceDetailPage';
import warehouseImg from '../../images/offers-warehouse.jpg';

export const WarehousePage = () => (
  <ServiceDetailPage
    meta={{
      title: 'Warehouse & Storage — Renuit Logistics',
      description: 'Flexible short and long-term warehousing in the Tampa Bay metro. Climate-controlled storage, inventory management, pick-pack, and kitting.',
      canonical: 'https://www.renuit.pro/services/warehouse-storage',
    }}
    hero={{
      image: warehouseImg,
      tag: 'Tampa Bay Metro',
      heading: 'Warehouse & Storage',
      subheading: 'Flexible short and long-term storage in our Tampa Bay climate-controlled facility. Inventory you can see, managed by people you can reach.',
    }}
    detail={{
      heading: 'Storage That Works Around Your Business',
      subheading: 'Whether you need overflow capacity during peak season or a permanent distribution point in Tampa Bay, we provide storage that fits your volume and budget — not the other way around.',
      features: [
        'Short-term and long-term storage options',
        'Climate-controlled and standard warehouse bays',
        'Inventory management with periodic reporting',
        'Pick, pack, and kitting services',
        'Inbound freight receiving and inspection',
        'Outbound load staging and coordination',
        'No long-term minimum contracts required for overflow',
      ],
      image: warehouseImg,
    }}
    steps={[
      { n: '01', title: 'Tell us your volume', body: 'Describe your commodity, pallet count, and storage timeline. We assess fit the same day.' },
      { n: '02', title: 'Review your storage agreement', body: 'We provide a clear breakdown of storage rates, handling fees, and reporting cadence.' },
      { n: '03', title: 'Ship your inventory', body: 'We coordinate inbound receiving, inspect freight on arrival, and palletize to your specs.' },
      { n: '04', title: 'Monitor via reports', body: 'Regular inventory counts and a dedicated contact means you always know what is in our facility.' },
    ]}
    faq={[
      { q: 'Is your warehouse climate-controlled?', a: 'Yes. We offer climate-controlled bays for temperature-sensitive goods, including electronics, pharmaceuticals, and perishables with appropriate dwell times.' },
      { q: 'Do you do cycle counts and inventory reporting?', a: 'Yes. Clients receive inventory reports on a cadence you specify. Cycle counts can be performed on request at no additional charge for active accounts.' },
      { q: 'Is there a minimum storage commitment?', a: 'For dedicated storage accounts, we typically ask for a 30-day minimum. Overflow and spot storage is available on shorter terms depending on availability.' },
      { q: 'Can you receive inbound freight from other carriers?', a: 'Yes. We accept inbound freight from any carrier. We document condition on arrival and notify you of any discrepancies before signing the BOL.' },
    ]}
    cta={{
      heading: 'Need Storage in Tampa Bay?',
      subheading: 'Tell us your volume and we\'ll confirm availability the same day.',
      primaryText: 'Request a Storage Quote',
      primaryTo: '/quote',
      phone: '(786) 628-3731',
    }}
  />
);
